/* ROLES */
export const API_RESPONSE_SUCCESS = "API_RESPONSE_SUCCESS"
export const API_RESPONSE_ERROR = "API_RESPONSE_ERROR"

export const UPDATE_SYSTEM_SETTING = "UPDATE_SYSTEM_SETTING"
export const GET_SYSTEM_SETTING = "GET_SYSTEM_SETTING"

export const CLEAR_MESSAGE = "CLEAR_MESSAGE"
